import styled, { css } from 'styled-components';
import { IframeContent } from '../iframeContent';
import { FormType } from './iframeForm.component';
import { media } from '../../theme/media';
import { BoxShadow as BoxShadowComponent } from '../boxShadow/boxShadow.component';
import { Content as ContentBoxShadow } from '../boxShadow/boxShadow.styles';

const donateStyles = css`
  max-width: 375px;

  ${media.tablet`
    max-width: 859px;
    padding-left: 42px;
    padding-right: 42px;
  `};

  ${media.tabletLarge`
    padding-left: 0;
    padding-right: 0;
  `};

  ${media.desktop`
    margin-top: 265px;
  `};

  ${media.desktopFull`
    max-width: 1059px;
    padding-right: 200px;
  `};
`;

const fastActionNetworkStyles = css`
  ${donateStyles};

  ${media.desktop`
    margin-top: 0;
  `};
`;

const takeActionStyles = css`
  ${donateStyles}

  ${media.desktop`
    margin-top: 0;
  `};

  ${media.desktopFull`
    max-width: 859px;
    padding-right: 0;
  `}
`;

const eventStyles = css`
  padding-left: 13px;
  padding-right: 13px;
  max-width: 1322px;

  ${media.tablet`
    padding-left: 31px;
    padding-right: 31px;
  `}

  ${media.desktop`
    padding:0;
  `}
`;

const getFormStyles = ({ type }) => {
  if (type === FormType.DONATE) {
    return donateStyles;
  }

  if (type === FormType.FAST_ACTION_NETWORK) {
    return fastActionNetworkStyles;
  }

  if (type === FormType.TAKE_ACTION) {
    return takeActionStyles;
  }

  if (type === FormType.EVENTS) {
    return eventStyles;
  }

  return '';
};

export const FrameContent = styled(IframeContent)`
  ${getFormStyles}
`;

export const BoxShadow = styled(BoxShadowComponent)`
  max-width: 375px;
  margin: 60px 24px;

  ${media.tablet`
    max-width: 859px;
    margin-top: 60px;
    margin-bottom: 80px;
  `};

  ${media.tabletLarge`
    margin-top: 80px;
    margin-bottom: 100px;
   `};

  ${media.desktop`
    margin-top: 100px;
   `};

  ${media.desktopFull`
    max-width: 1059px;
  `};

  ${ContentBoxShadow} {
    width: 100%;
    padding: 24px 24px 100px;

    ${media.tablet`
      padding: 56px;
    `};
  }
`;
